<template>
  <div class="instruction_list">
    <template v-for="(item, index) in fileData">
      <div class="btn" :key="index" v-if="item.file_name">
        <a :href="`${storage}${item.file_path}?${time}`">
          <button :class="type=='inner'?'btn_primary':'btn_border'">{{ item.file_name }}</button>
        </a>
      </div>
    </template>
    <template v-for="(item, index) in orderData">
      <!-- {{storage}}{{item.file_path}} -->
      <div class="btn" :key="index" v-if="item.file_name">
        <a :href="`${storage}${item.file_path}?${time}`">
          <button :class="type=='inner'?'btn_primary':'btn_border'">{{ item.file_name }}</button>
        </a>
      </div>
    </template>
  </div>
</template>
<style lang="scss">
.instruction_list {
  .btn {
    margin: 10px 0;
    max-width: 250px;
    button {
      white-space: normal;
    }
  }
}
</style>
<script>
import * as moment from "moment";
export default {
  name: "instruction",
  data() {
    return {
      fileData: [],
      orderData: [],
    };
  },
  props: {
    type: String,
  },
  computed: {
    storage() {
      return this.$http.base.storage;
    },
    time() {
      return moment().format();
    },
  },
  methods: {
    getData() {
      this.$http.api.file.guideDow().then((res) => {
        this.fileData = res.data;
      });
    },
    getOrderData() {
      this.$http.api.file.getOrder().then((res) => {
        this.orderData = res.data;
      });
    },
  },
  created() {
    this.getData();
    this.getOrderData();
  },
};
</script>